import { useCallback, useEffect, useState } from "react";
import { toast } from "sonner";
import { isSyncing, listQueue, onQueueChange, syncQueue } from "../lib/offlineQueue";

// Online status + items waiting to upload; auto-syncs when signal returns.
export const useOfflineSync = (eventId, onSynced) => {
  const [online, setOnline] = useState(navigator.onLine);
  const [pending, setPending] = useState([]);
  const [syncing, setSyncing] = useState(false);

  const refresh = useCallback(async () => {
    setPending(await listQueue(eventId));
    setSyncing(isSyncing());
  }, [eventId]);

  const syncNow = useCallback(async () => {
    const n = await syncQueue();
    if (n > 0) {
      toast.success(`Synced ${n} saved contact${n === 1 ? "" : "s"}`);
      onSynced?.();
    }
  }, [onSynced]);

  useEffect(() => {
    refresh();
    const off = onQueueChange(refresh);
    const up = () => { setOnline(true); syncNow(); };
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    const t = setInterval(() => { if (navigator.onLine) syncNow(); }, 30000);
    if (navigator.onLine) syncNow();
    return () => {
      off();
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
      clearInterval(t);
    };
  }, [refresh, syncNow]);

  return { online, pending, syncing, syncNow };
};

export default useOfflineSync;
